import styled from 'styled-components';

export const AttachmentsGallerySC = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  background: #fff;

  .ag-loading {
    padding: 15px 0;
    text-align: center;
  }

  .ag-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .ag-empty {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    color: #333d6c;
    opacity: 0.4;
    text-align: center;
    font-size: 22px;
    line-height: 30px;
  }
`;

export const TAttachmentCellSC = styled.div`
  position: relative;
  float: left;
  background: #f4f5f7;
  border: 1px solid #fff;
  width: 25%;
  overflow: hidden;
  cursor: pointer;

  @media (max-width: 1100px) {
    width: 33.333%;
  }

  @media (min-width: 1600px) {
    width: 20%;
  }

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  &:hover {
    opacity: 0.8;
  }

  .ac-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .ac-doc {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 15px;
    font-weight: bold;
  }
`;
